import { gsap } from 'gsap';

class Collapse {
	constructor(button, container) {
		this.button = button;
		this.container = container;
		this.targets = this.container.querySelectorAll(this.button.dataset.toggleTarget);
		this.isAnimating = false;

		this.button.addEventListener('click', (e) => {
			this.toggle();
		});
	}

	toggle() {
		if (this.isAnimating) {
			return;
		}

		this.isAnimating = true;

		const isShowing = this.button.classList.contains('is-active') ? true : false;

		Promise.all(
			Array.from(this.targets).map(
				(item) =>
					new Promise((resolve) => {
						if (isShowing) {
							// Hide target
							gsap.set(item, {
								height: item.scrollHeight,
							});

							const tl = gsap.timeline({
								onComplete: () => {
									gsap.set(item, {
										height: 0,
									});
									resolve();
								},
							});

							tl.to(item, {
								opacity: 0,
								duration: 0.3,
								ease: 'none',
							});
							tl.to(item, {
								height: 0,
								duration: 0.15,
								ease: 'none',
							});
						} else {
							// Show target
							const height = item.scrollHeight;

							gsap.set(item, {
								opacity: 0,
							});

							const tl = gsap.timeline({
								onComplete: () => {
									gsap.set(item, {
										height: 'auto',
									});

									resolve();
								},
							});

							tl.to(item, {
								targets: item,
								height: height,
								duration: 0.15,
								ease: 'none',
							});

							tl.to(item, {
								targets: item,
								opacity: 1,
								duration: 0.3,
								ease: 'none',
							});
						}
					}),
			),
		).then(() => {
			// When all transitions are finished
			this.isAnimating = false;
		});

		if (isShowing) {
			this.button.classList.remove('is-active');
		} else {
			this.button.classList.add('is-active');
		}
	}
}

export default class CollapseManager {
	constructor() {
		document.addEventListener('bless', ({ detail }) => {
			this.init(detail.next.container);
		});
	}

	init(container) {
		const buttons = container.querySelectorAll('[data-toggle-target]');

		buttons.forEach((button) => {
			new Collapse(button, container);
		});
	}
}
